import { NavigationGroup } from "./navigation-item.model";

export const CUSTOMER_NAVIGATION_ITEMS: NavigationGroup[] = [
  {
    items: [
      { title: 'nav.items.logout', icon: 'bi bi-box-arrow-right', link: '/login' }
    ]
  }
];
